/**
 * Lab Report Library Component
 * Handles live search filtering, category filtering, and batch copying.
 */
class LabReportLibrary extends HTMLElement {
  constructor() {
    super();
    this.searchInput = this.querySelector('[data-lab-search]');
    this.filterButtons = this.querySelectorAll('[data-filter]');
    this.items = this.querySelectorAll('.lab-reports__item');
    this.emptyMessage = this.querySelector('[data-lab-empty]');
    this.currentFilter = 'all';
    this.searchQuery = '';

    this.init();
  }

  init() {
    if (this.searchInput) {
      this.searchInput.addEventListener('input', (e) => {
        this.searchQuery = e.target.value.trim().toLowerCase();
        this.filterReports();
      });
    }

    this.filterButtons.forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        this.filterButtons.forEach((b) => {
          b.setAttribute('aria-pressed', 'false');
          b.classList.remove('lab-reports__filter--active');
        });
        btn.setAttribute('aria-pressed', 'true');
        btn.classList.add('lab-reports__filter--active');
        this.currentFilter = btn.dataset.filter || 'all';
        this.filterReports();
      });
    });

    // Copy batch button handlers
    this.querySelectorAll('[data-copy-text]').forEach((btn) => {
      btn.addEventListener('click', async (e) => {
        e.preventDefault();
        const text = btn.dataset.copyText;
        if (!text) return;
        try {
          await navigator.clipboard.writeText(text);
          const originalText = btn.innerHTML;
          btn.classList.add('kerva-copy-btn--copied');
          setTimeout(() => {
            btn.classList.remove('kerva-copy-btn--copied');
          }, 2000);
        } catch (err) {
          console.warn('Clipboard copy failed:', err);
        }
      });
    });
  }

  filterReports() {
    let visibleCount = 0;

    this.items.forEach((item) => {
      const category = item.dataset.category || '';
      const searchIndex = item.dataset.search || '';

      const matchesCategory =
        this.currentFilter === 'all' || category === this.currentFilter;
      const matchesSearch =
        !this.searchQuery || searchIndex.includes(this.searchQuery);

      if (matchesCategory && matchesSearch) {
        item.removeAttribute('hidden');
        item.style.display = '';
        visibleCount++;
      } else {
        item.setAttribute('hidden', '');
        item.style.display = 'none';
      }
    });

    if (this.emptyMessage) {
      if (visibleCount === 0) {
        this.emptyMessage.removeAttribute('hidden');
      } else {
        this.emptyMessage.setAttribute('hidden', '');
      }
    }
  }
}

if (!customElements.get('lab-report-library')) {
  customElements.define('lab-report-library', LabReportLibrary);
}
